export const getVersion = state => {
	state = Number(state)
	switch (state) {
		case 1:
			return 'PRICING_NEW_COMMON_FREE'
		case 2:
			return 'PRICING_NEW_COMMON_PRO'
		case 3:
			return 'PRICING_NEW_COMMON_ADVANCE'
		case 4:
			return 'TEAM_MEMBER'
		case 5:
			return 'TEAM_ADMIN'
		case 6:
			return 'FROZEN_STATE'
		case 7:
			return 'PRICING_NEW_COMMON_BASIC'
		default:
			return 'PRICING_NEW_COMMON_FREE'
	}
}

export const baseData = {
	pro: {
		name: 'PRICING_NEW_COMMON_PRO',
		price: 30,
		baseStorage: 30,
		addedPermonth: 1,
		plan: 'PAID1',
		month: {
			added: 0,
			times: 1,
			permonth: 'PRICING_NEW_PAY_PRO1',
			storage: PageInfo.storage1monthPro,
			total: PageInfo.paid1monthPro,
			expried: PageInfo.exp1monthPro,
			text: 'PRICING_NEW_COMMON_ONE_MONTH',
			textMobile: 'PRICING_NEW_PAY_PRO_MONTH',
			price: 30,
		},
		halfYear: {
			saveText: 'PRICING_NEW_PAY_PRO2_SAVETEXT',
			added: 6,
			times: 6,
			permonth: 'PRICING_NEW_PAY_PRO2',
			storage: PageInfo.storage6monthPro,
			total: PageInfo.paid6monthPro,
			expried: PageInfo.exp6monthPro,
			text: 'PRICING_NEW_COMMON_HALF_YEAR',
			textMobile: 'PRICING_NEW_PAY_PRO_HALFYEAR',
			price: 30,
		},
		year: {
			saveText: 'PRICING_NEW_PAY_PRO3_SAVETEXT',
			added: 12,
			times: 12,
			permonth: 'PRICING_NEW_PAY_PRO3',
			storage: PageInfo.storage12monthPro,
			total: PageInfo.paid12monthPro,
			expried: PageInfo.exp12monthPro,
			text: 'PRICING_NEW_COMMON_ONE_YEAR',
			textMobile: 'PRICING_NEW_PAY_PRO_YEAR',
			price: 30,
		},
	},
	advance: {
		name: 'PRICING_NEW_COMMON_ADVANCE',
		price: 60,
		baseStorage: 72,
		addedPermonth: 2,
		plan: 'PAID2',
		month: {
			added: 0,
			times: 1,
			permonth: 'PRICING_NEW_PAY_ADVANCE1',
			storage: PageInfo.storage1monthAdvance,
			total: PageInfo.paid1monthAdvance,
			expried: PageInfo.exp1monthAdvance,
			text: 'PRICING_NEW_COMMON_ONE_MONTH',
			textMobile: 'PRICING_NEW_PAY_ADVANCE_MONTH',
			price: 60,
		},
		halfYear: {
			saveText: 'PRICING_NEW_PAY_ADVANCE2_SAVETEXT',
			added: 12,
			times: 6,
			permonth: 'PRICING_NEW_PAY_ADVANCE2',
			storage: PageInfo.storage6monthAdvance,
			total: PageInfo.paid6monthAdvance,
			expried: PageInfo.exp6monthAdvance,
			text: 'PRICING_NEW_COMMON_HALF_YEAR',
			textMobile: 'PRICING_NEW_PAY_ADVANCE_HALFYEAR',
			price: 60,
		},
		year: {
			saveText: 'PRICING_NEW_PAY_ADVANCE3_SAVETEXT',
			added: 24,
			times: 12,
			permonth: 'PRICING_NEW_PAY_ADVANCE3',
			storage: PageInfo.storage12monthAdvance,
			total: PageInfo.paid12monthAdvance,
			expried: PageInfo.exp12monthAdvance,
			text: 'PRICING_NEW_COMMON_ONE_YEAR',
			textMobile: 'PRICING_NEW_PAY_ADVANCE_YEAR',
			price: 60,
		},
	},
	eaglePro: {
		name: 'PRICING_NEW_COMMON_PRO',
		price: 30,
		baseStorage: 30,
		addedPermonth: 1,
		plan: 'PAID1',
		year: {
			added: 12,
			times: 12,
			permonth: 'PRICING_NEW_PAY_PRO3',
			storage: PageInfo.storage12monthEagle,
			total: PageInfo.paid12monthEagle,
			expried: PageInfo.exp12monthEagle,
			text: 'PRICING_NEW_COMMON_ONE_YEAR',
		},
	},
	eagleAdvance: {
		name: 'PRICING_NEW_COMMON_ADVANCE',
		price: 60,
		baseStorage: 72,
		addedPermonth: 2,
		plan: 'PAID2',
		year: {
			added: 24,
			times: 12,
			permonth: 'PRICING_NEW_PAY_ADVANCE3',
			storage: PageInfo.storage12monthAdvance,
			total: PageInfo.paid12monthAdvance,
			expried: PageInfo.exp12monthAdvance,
			text: 'PRICING_NEW_COMMON_ONE_YEAR',
			textMobile: 'PRICING_NEW_PAY_ADVANCE_YEAR',
		},
	},
	boxcryptorPro: {
		name: 'PRICING_NEW_COMMON_PRO',
		price: 30,
		baseStorage: 30,
		addedPermonth: 1,
		plan: 'PAID1',
		year: {
			added: 12,
			times: 12,
			permonth: 'PRICING_NEW_PAY_PRO3',
			storage: PageInfo.storage12monthEagle,
			total: PageInfo.paid12monthEagle,
			expried: PageInfo.exp12monthEagle,
			text: 'PRICING_NEW_COMMON_ONE_YEAR',
		},
	},
	boxcryptorAdvance: {
		name: 'PRICING_NEW_COMMON_ADVANCE',
		price: 60,
		baseStorage: 72,
		addedPermonth: 2,
		plan: 'PAID2',
		year: {
			added: 24,
			times: 12,
			permonth: 'PRICING_NEW_PAY_ADVANCE3',
			storage: PageInfo.storage12monthAdvance,
			total: PageInfo.paid12monthAdvance,
			expried: PageInfo.exp12monthAdvance,
			text: 'PRICING_NEW_COMMON_ONE_YEAR',
			textMobile: 'PRICING_NEW_PAY_ADVANCE_YEAR',
		},
	},
}
